import {Slider} from '@components/slider';

interface Props {
    group: string;
    disabled?: boolean;
}

export const HoursInput = (props: Props) => {
    const {group} = props
    return (
        <>
            <Slider
                disabled={props.disabled}
                name={`${group}.weekdays`}
                label="Yrkadagar"
                maxValue={40}
                minValue={0}
                step={1}
                renderLabel={(value) => <>{props.disabled ? '-' : value} tímar</>}
            />
            <Slider
                disabled={props.disabled}
                name={`${group}.saturday`}
                label="Leygardag"
                maxValue={8}
                minValue={0}
                step={1}
                renderLabel={(value) => <>{props.disabled ? '-' : value} tímar</>}
            />
            <Slider
                disabled={props.disabled}
                name={`${group}.sunday`}
                label="Sunnudag"
                maxValue={8}
                minValue={0}
                step={1}
                renderLabel={(value) => <>{props.disabled ? '-' : value} tímar</>}
            />
        </>
    )
}
